import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { TitleId } from '@domgen/dgx-fe-common';
import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { GroupMarketingPreferencesForm } from '../group-marketing-preferences/group-marketing-preferences-form.interface';
import { PersonalDetailsFormField } from './personal-details-form-field.enum';

export interface PersonalDetailsForm {
  [PersonalDetailsFormField.AddProtectionPolicy]: FormControl<boolean>;
  [PersonalDetailsFormField.Address]: AbstractControl<FormOverrideAddress>;
  [PersonalDetailsFormField.GroupMarketingPreferences]: FormGroup<GroupMarketingPreferencesForm>;
  [PersonalDetailsFormField.EmailAddress]: FormControl<string | null>;
  [PersonalDetailsFormField.FirstName]: FormControl<string | null>;
  [PersonalDetailsFormField.LastName]: FormControl<string | null>;
  [PersonalDetailsFormField.MarketingPreferenceEmail]: FormControl<boolean>;
  [PersonalDetailsFormField.MarketingPreferencePost]: FormControl<boolean>;
  [PersonalDetailsFormField.MarketingPreferenceTelephone]: FormControl<boolean>;
  [PersonalDetailsFormField.PrivacyPolicy]: FormControl<boolean>;
  [PersonalDetailsFormField.TelephoneNumber]: FormControl<string | null>;
  [PersonalDetailsFormField.TitleId]: FormControl<TitleId | null>;
}
